/**
 * Clone a matrix.
 */
export function matrixClone(matrix) {
    return matrix.map((row) => row.slice(0));
}
//# sourceMappingURL=matrixClone.js.map